import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-center font-semibold text-2xl py-3" }, "Add candidate to job", -1)
const _hoisted_3 = { class: "flex flex-col w-full my-3" }
const _hoisted_4 = { class: "w-full space-y-3" }
const _hoisted_5 = { class: "flex flex-row justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.company_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company_id) = $event)),
              options: _ctx.companies,
              label: "name",
              placeholder: "Select company",
              reduce: (name) => name.id
            }, null, 8, ["modelValue", "options", "reduce"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.job_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.job_id) = $event)),
              options: _ctx.jobs,
              disabled: !_ctx.company_id || _ctx.jobs.length <= 0,
              label: "name",
              placeholder: 
                _ctx.company_id && _ctx.jobs.length <= 0
                  ? 'No jobs in this company'
                  : 'Select job'
              ,
              reduce: (name) => name.id
            }, null, 8, ["modelValue", "options", "disabled", "placeholder", "reduce"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          type: "submit",
          label: "Submit",
          variant: "contained",
          disabled: !_ctx.meta.dirty || !_ctx.meta.valid || _ctx.isLoadingButton
        }, null, 8, ["disabled"])
      ])
    ], 32)
  ]))
}